<template>
  <AuditLayout>
    <router-view></router-view>
  </AuditLayout>
</template>
<script>
import AuditLayout from "@/layout/AuditLayout.vue";
export default {
  name: "index",
  props: {},
  components: { AuditLayout },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
